module.exports = __webpack_public_path__ + "static/media/Tawuniya-Logo-light.0146c545.svg";